export const setPostId = (postId) => (dispatch) => {
  dispatch({ type: "ADD_POST_ID", payload: postId });
};
